import React from "react";
import debounce from "lodash.debounce";
// 引入HOC高阶函数withTranslation 和 i18n的ts类型定义WithTranslation
import { withTranslation, WithTranslation } from "react-i18next";
// import CountTo from "react-count-to";
import Nav from "./Nav";
import "../../assets/styles/newStyle.scss";
import "../../assets/styles/secondPage.scss";
class CBUComponent extends React.Component<WithTranslation> {
  state = {
    scale: "",
    imageWidth: "",
    imageHeight: "",
    navForm: null,
    scrollTop: null,
    num1: 0,
    num2: 0,
    num3: 0,
    imageShow: false,
    imageMaxHeight: null,
    topIconShow: false,
    topClick: false,
  };
  componentWillUnmount() {
    this.setState = () => false;
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({ scale: this.getScale() });
    }, 500);
    window.addEventListener("resize", this.setScale);
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }
  handleScroll = () => {
    //滚动条高度
    let scrollTop = document.documentElement.scrollTop; //滚动条滚动高度
    // console.log(scrollTop);
    // console.log(this.state.scale)
    if (scrollTop >= 300) {
      this.setState({
        topIconShow: true,
      });
    } else {
      this.setState({
        topIconShow: false,
      });
    }
    this.setState({
      scrollTop,
    });
    let show_num = null;
    let hide_num = null;
    if (this.state.imageShow) {
      show_num = 4500;
      hide_num = 4300;
      if (this.state.scale > 1.5) {
        show_num = 4800;
        hide_num = 4500;
      }
    } else {
      show_num = 3000;
      hide_num = 2800;
      if (this.state.scale > 1.5) {
        show_num = 3280;
        hide_num = 3080;
      }
    }
    // console.log('显示：' + show_num * this.state.scale)
    // console.log('隐藏：' + hide_num * this.state.scale)
    if (scrollTop >= show_num * this.state.scale) {
      return this.setState({
        num1: 550,
        num2: 7,
        num3: 260,
      });
    } else if (scrollTop <= hide_num * this.state.scale) {
      return this.setState({
        num1: 0,
        num2: 0,
        num3: 0,
      });
    }
  };
  // 将子组件传过来的实例赋值给navForm
  onRef = (ref) => {
    // eslint-disable-next-line
    this.state.navForm = ref;
    this.state.navForm.setState({
      background_is_black: false,
    });
    // console.log(this.state.navForm);
  };
  // 导航栏跳页面
  toPage = (index) => {
    // console.log(index);
    this.props.history.push("/");
    window.localStorage.setItem("swiperPage", index);
  };
  // 返回首页
  toPageHome = () => {
    this.props.history.push("/");
  };
  // 语言切换
  langChange = () => {
    // console.log("语言切换");
    const { i18n } = this.props;
    i18n.changeLanguage(i18n.language === "zh_cn" ? "en" : "zh_cn");
    // this.state.player.load();
    // this.state.mySwiper.disable()
  };
  //得到呈现的屏幕宽高比
  getScale = () => {
    const { width = 1028 } = this.props;
    let ww = window.innerWidth / width;
    return ww < 1 ? 1 : ww;
  };
  setScale = debounce(() => {
    let scale = this.getScale();
    this.setState({ scale });
  }, 500);
  // 滚动页面
  toMore = () => {
    window.location.hash = "";
    window.location.hash = "carService";
  };
  // 显示图片部分
  toShowImage = () => {
    this.setState({
      imageShow: true,
      imageMaxHeight: this.imageDom.clientHeight,
    });
    setTimeout(() => {
      window.location.hash = "";
      window.location.hash = "framework";
    }, 300);
  };
  // 服务优势
  toContact = () => {
    this.props.history.push("/");
    window.localStorage.setItem("swiperPage", 4);
  };
  // 回到顶部
  toTop = () => {
    this.setState({
      topClick: true,
    });
    setTimeout(() => {
      this.setState({
        topClick: false,
      });
    }, 500);
    // this.refDom.scrollTop = 0;
    // console.log(this.state.scrollTop)
    // var osTop = this.state.scrollTop
    // // 缓冲
    // const timer = setInterval(() => {
    //   // 再次获取滚动条距顶部高度
    //   console.log(osTop)
    //   // 用于设置速度差,产生缓慢效果
    //   var speed = -20;
    //   osTop = osTop + speed;
    //   this.refDom.scrollTop = osTop;
    //   if (osTop === 0) {
    //     clearInterval(timer);
    //     this.setState({
    //       topClick: false,
    //     });
    //   }
    // }, 1000);
  };
  // 二级页面
  toSecondPage = (page) => [this.props.history.push("/" + page)];
  render() {
    const { t, i18n } = this.props;
    const {
      scale,
      imageShow,
      imageMaxHeight,
      topIconShow,
      topClick,
    } = this.state;
    return (
      <div
        className="EBU"
        ref={(ref) => {
          this.refDom = ref;
        }}
        style={{
          height: topClick ? "100vh" : "auto",
        }}
      >
        {/* 导航栏 */}
        <Nav
          onRef={this.onRef}
          navIndex={2}
          langChange={this.langChange}
          toPageSwiper={this.toPage}
          toSecondPage={this.toSecondPage}
          logoClick={this.toPageHome}
          navList={t("navList")}
          navListLevel={t("navListLevel")}
          lang={i18n.language}
          className={"nav-no-fixed"}
        />
        {/* <a href="#activity1">1212</a> */}
        <div className="secondPage-container">
          <img
            className="EBU_bg"
            src={require("@/assets/images/CBU_1.png").default}
            alt=""
          />
          {/* 车联服务锚点 */}
          <div
            id="carService"
            className="area_click"
            style={{
              width: `${165 * scale}px`,
              height: `${45 * scale}px`,
              top: `${600 * scale}px`,
              left: `${130 * scale}px`,
            }}
          ></div>
          {/* 了解更多 */}
          <div
            className="area_click"
            onClick={this.toMore}
            style={{
              width: `${165 * scale}px`,
              height: `${45 * scale}px`,
              top: `${369 * scale}px`,
              left: `${130 * scale}px`,
            }}
          />
          {/* 总体架构查看更多 */}
          <div
            className="area_click"
            onClick={this.toShowImage}
            style={{
              width: `${165 * scale}px`,
              height: `${65 * scale}px`,
              top: `${2480 * scale}px`,
              left: `${431 * scale}px`,
            }}
          />
          {/* <div id='activity1'>1111</div> */}
          {/* 第二张图 */}
          <div
            className={`${imageShow ? "height-auto" : "displayNone"}`}
            style={{
              maxHeight: imageMaxHeight,
            }}
          >
            <img
              className="EBU_bg"
              src={require("@/assets/images/CBU_2.png").default}
              alt=""
              ref={(ref) => {
                this.imageDom = ref;
              }}
            />
            {/* 第二张图锚点 */}
            <div
              id="framework"
              className="area_click"
              style={{
                width: `${165 * scale}px`,
                height: `${45 * scale}px`,
                top: `${2600 * scale}px`,
                left: `${130 * scale}px`,
              }}
            ></div>
          </div>
          {/* 第三张图 */}
          <img
            className="EBU_bg"
            src={require("@/assets/images/CBU_3.png").default}
            alt=""
          />
          {/* 服务优势-了解更多 */}
          <div
            className="area_click"
            onClick={this.toContact}
            style={{
              width: `${195 * scale}px`,
              height: `${45 * scale}px`,
              bottom: `${1070 * scale}px`,
              left: `${90 * scale}px`,
            }}
          />
          {/* 数字统计 start*/}
          <div
            className="count-box"
            style={{
              width: `${240 * scale}px`,
              bottom: `${232 * scale}px`,
              left: `${173 * scale}px`,
              fontSize: `${40 * scale}px`,
            }}
          >
            {/* 8,100,000 */}
            14,895,759
            {/* <CountTo to={num1} speed={2000} className="count-num"></CountTo> */}
            <span
              className="count-text"
              style={{
                fontSize: `${20 * scale}px`,
              }}
            >
              +
            </span>
            <div className="count-des">车联用户<br />截止2025年06月20日</div>
          </div>
          {/* <div
            className="count-box"
            style={{
              width: `${100 * scale}px`,
              bottom: `${232 * scale}px`,
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: `${40 * scale}px`,
            }}
          >
            <CountTo to={num2} speed={1000} className="count-num"></CountTo>
            <span
              className="count-text"
              style={{
                fontSize: `${20 * scale}px`,
              }}
            >
              亿
            </span>
          </div> */}
          <div
            className="count-box"
            style={{
              width: `${240 * scale}px`,
              bottom: `${232 * scale}px`,
              right: `${196 * scale}px`,
              fontSize: `${40 * scale}px`,
            }}
          >
            {/* 7,600,000 */}
            11,812,955
            {/* <CountTo to={7600000} speed={2000} className="count-num"></CountTo> */}
            <span
              className="count-text"
              style={{
                fontSize: `${20 * scale}px`,
              }}
            >
              +
            </span>
            <div className="count-des">在线用户<br />截止2025年06月20日</div>
          </div>
          {/* 数字统计 end*/}
        </div>
        {/* 返回顶部 */}
        {topIconShow ? (
          <div className="toTop" onClick={this.toTop}>
            <img src={require("@/assets/images/toTop.png").default} alt="" />
          </div>
        ) : null}
      </div>
    );
  }
}
export const CBU = withTranslation()(CBUComponent); // 使用withTranslation高阶函数来完成语言配置的数据注入
